@if ($showHeaderAuto()){
    <div class="w-list-header">
        <div class="w-list-header-title">
            @if($headerTitle(); as title) {
                <span *dynamicView="title"></span>
            }
        </div>
        <div class="w-list-header-actions">
            @if($headerActionContent()) {
                <span *dynamicView="$headerActionContent()"></span>
            }@else if($headerActions()) {
                @for(action of $headerActions(); track action) {
                    <w-button displayStyle="Tertiary" size="Small" [command]="action" />
                }
            }
        </div>
    </div>
}


<div class="w-list-body">

    <ng-content [select]="'w-content-list-item'"></ng-content>

</div>

@if ($showFooter()){
    <div class="w-list-footer">

        <div class="w-list-header-actions">

            @if ($footerLeftContent()){
                <span *dynamicView="$footerLeftContent()"></span>
            } @else if($footerLeftCommands()) {
                @for(action of $footerLeftCommands(); track action) {
                    <w-button displayStyle="Tertiary" size="Medium" [command]="action" />
                }
            }

        </div>

        <div class="w-list-header-actions">

            @if ($footerRightContent()){
                <span *dynamicView="$footerRightContent()"></span>
            } @else if($footerRightCommands()) {
                @for(action of $footerRightCommands(); track action) {
                    <w-button displayStyle="Tertiary" size="Medium" [command]="action" />
                }
            }

        </div>

    </div>
}